// src/lib/saleService.js
import { orderSaleIdempotencyKey, processSaleApi } from './salesApi';

const STORE_ID = 'SUC001';

const localYMD = () => {
  const d = new Date();
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
};

export async function processOrderSale({
  order,
  cashier,
  paymentMethod,
  amount1,
  paymentMethod2,
  amount2,
  turnId,
}) {
  const nowISO = new Date().toISOString();
  const dateKey = localYMD();
  const idempotencyKey = orderSaleIdempotencyKey(order?.id);

  const saleDoc = {
    date: nowISO,
    fecha: dateKey,
    dateKey,
    customerName: order?.table || 'Consumidor Final',
    products: (order?.items || []).map((item) => ({
      id: item.id,
      name: item.name,
      quantity: Number(item.quantity || 0),
      price: Number(item.price || 0),
      barcode: item.barcode || '',
      recipe: Array.isArray(item.recipeComponents) ? item.recipeComponents : null,
    })),
    paymentMethod,
    secondPaymentMethod: paymentMethod2 || null,
    amountReceived: Number(amount1 || 0),
    secondAmountReceived: Number(amount2 || 0),
    status: 'Completada',
    origin: 'direct_charge',
    orderRef: order?.id || null,
    turnId: turnId || null,
    storeId: STORE_ID,
    orderInfo: {
      table: order?.table || null,
      waiterUid: order?.waiterUid || null,
      waiterName: order?.waiterName || order?.waiter || null,
    },
  };

  const result = await processSaleApi({ saleDoc, storeId: STORE_ID, idempotencyKey });
  return {
    ventaId: result.ventaId || result.saleId,
    invoiceNumber: result.invoiceNumber,
    subtotal: Number(result.subtotal || 0),
    tax: Number(result.tax || 0),
    total: Number(result.total || 0),
    change: Number(result.change || 0),
    idempotentReplay: result.idempotentReplay === true,
  };
}
